module.exports = __webpack_public_path__ + "static/media/how-to-bind-device.2ba1be6a.png";